import { render, staticRenderFns } from "./administrativeDocumentAdd.vue?vue&type=template&id=cc5b5904&scoped=true"
import script from "./administrativeDocumentAdd.vue?vue&type=script&lang=js"
export * from "./administrativeDocumentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5b5904",
  null
  
)

export default component.exports